import { CATEGORY_META } from "../lib/icons";

export type Counts = Record<string, number>;

interface Props {
  active: string | null; // single-selection, mirrors the design's behavior
  counts: Counts;
  onSelect: (category: string | null) => void;
}

const ORDER = ["reminder", "event", "task", "note", "link", "shopping"];

export function Chips({ active, counts, onSelect }: Props) {
  const total = Object.values(counts).reduce((a, b) => a + b, 0);
  return (
    <div className="chips desktop-chips" role="group" aria-label="Category filters">
      <button
        className="chip"
        aria-pressed={active === null}
        onClick={() => onSelect(null)}
      >
        <span style={{ color: "var(--text-muted)" }}>All</span>
        <span className="count">{total}</span>
      </button>
      {ORDER.map((c) => {
        const meta = CATEGORY_META[c];
        if (!meta) return null;
        const on = active === c;
        const Glyph = meta.icon;
        // Collapsed chips show only their (category-colored) icon + count, so
        // the row stays tidy as categories grow. The active chip expands to
        // reveal its label. The icon carries the identity a bare dot couldn't.
        return (
          <button
            key={c}
            className="chip chip-cat"
            aria-pressed={on}
            aria-label={meta.plural}
            title={meta.plural}
            style={{ ["--chip-color" as string]: meta.color }}
            onClick={() => onSelect(on ? null : c)}
          >
            <span className="chip-icon">
              <Glyph />
            </span>
            {on && <span className="chip-label">{meta.plural}</span>}
            <span className="count">{counts[c] ?? 0}</span>
          </button>
        );
      })}
    </div>
  );
}
